module.exports = __webpack_public_path__ + "img/tooltip_icon.96cdcb41.svg";